<template>
  <foreignObject
    class="impact-icon"
    :width="18"
    :height="24"
  >
    <icon
      :style="{ color }"
      icon="cubelogo"
    />
  </foreignObject>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#1f2638',
    },
  },
}
</script>
